import React, { useState } from "react";
import axios from "axios";
import "../addBet.css";
import { NavLink } from "react-router-dom";

const AddBet = () => {
  const [formData, setFormData] = useState({
    title: "",
    titleLong: "",
    plan: "",
    odds: "",
    betRefUrl: [
      { type: "Sporty", url: "" },
      { type: "MSport", url: "" },
    ],
    betList: [],
  });
  const [priceInput, setPriceInput] = useState("");
  const [updatingPrice, setUpdatingPrice] = useState(false);

  const [isResuts, setIsResult] = useState(false);

  const [pasteText, setPasteText] = useState("");

  // const [currentBet, setCurrentBet] = useState({
  //   country: { long: "", short: "" },
  //   league: "",
  //   teams: { home: { long: "", short: "" }, away: { long: "", short: "" } },
  //   tip: { long: "", short: "" },
  //   time: "",
  // });

  const [loading, setLoading] = useState(false);

  const handleMainInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "odds" ? parseFloat(value) : value,
    }));
  };

  const handleBetRefChange = (index, field, value) => {
    const newBetRefUrl = [...formData.betRefUrl];
    newBetRefUrl[index][field] = value;
    setFormData((prev) => ({
      ...prev,
      betRefUrl: newBetRefUrl,
    }));
  };

  // const handleCurrentBetChange = (field, subField, value) => {
  //   setCurrentBet((prev) => {
  //     if (subField) {
  //       if (field === "teams") {
  //         const [teamType, teamField] = subField.split(".");
  //         return {
  //           ...prev,
  //           [field]: {
  //             ...prev[field],
  //             [teamType]: {
  //               ...prev[field][teamType],
  //               [teamField]: value,
  //             },
  //           },
  //         };
  //       }
  //       return {
  //         ...prev,
  //         [field]: { ...prev[field], [subField]: value },
  //       };
  //     }
  //     return { ...prev, [field]: value };
  //   });
  // };

  // const addBetToList = () => {
  //   if (
  //     currentBet.country.long &&
  //     currentBet.league &&
  //     currentBet.teams.home.long &&
  //     currentBet.teams.away.long &&
  //     currentBet.tip.long &&
  //     currentBet.time
  //   ) {
  //     setFormData((prev) => ({
  //       ...prev,
  //       betList: [...prev.betList, currentBet],
  //     }));
  //     setCurrentBet({
  //       country: { long: "", short: "" },
  //       league: "",
  //       teams: { home: { long: "", short: "" }, away: { long: "", short: "" } },
  //       tip: { long: "", short: "" },
  //       time: "",
  //     });
  //   } else {
  //     alert("Please fill all bet fields");
  //   }
  // };

  const removeBetFromList = (index) => {
    setFormData((prev) => ({
      ...prev,
      betList: prev.betList.filter((_, i) => i !== index),
    }));
  };

  const toggleBetResult = (index, checked) => {
    setFormData((prev) => ({
      ...prev,
      betList: prev.betList.map((b, i) =>
        i === index ? { ...b, outcome: checked } : b
      ),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title || !formData.odds || formData.betList.length === 0) {
      alert("Please fill all required fields and add at least one bet");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        isResuts ? "/result" : "/bet",
        formData
      );

      if (response.status === 200 || response.status === 201) {
        alert(`${isResuts ? "Result" : "Bet"} added successfully!`);
        setFormData({
          title: "",
          titleLong: "",
          plan: "",
          odds: "",
          betRefUrl: [
            { type: "Sporty", url: "" },
            { type: "Betway", url: "" },
          ],
          betList: [],
        });
      }
    } catch (error) {
      console.error("Error:", error);
      alert(error.response?.data?.message || "Error adding bet");
    } finally {
      setLoading(false);
    }
  };

  const parseBetValue = (e) => {
    e.preventDefault();
    // Split by "Game ID:" to separate matches
    const matches = e.clipboardData
      .getData("text")
      .split("Game ID:")
      .filter(Boolean);

    const parsedBets = matches.map((match) => {
      const lines = match
        .split("\n")
        .map((line) => line?.trim())
        .filter(Boolean);

      // console.log(match);

      // Parse first line for Game ID and DateTime
      const firstLine = lines[0];
      const [gameIdPart, datePart] = firstLine
        .split("|")
        .map((item) => item?.trim());
      const gameId = gameIdPart?.trim();
      const dateTime = datePart?.trim();

      // Find and parse teams line
      const teamsLine = lines.find((line) => line.includes(" v ")) || "";
      const [homeTeam, awayTeam] = teamsLine
        .split(" v ")
        .map((team) => team.trim());

      // Get Match Tracker comment
      let comment = "";
      const trackerIndex = lines.findIndex((line) =>
        line.includes("Match Tracker")
      );
      if (trackerIndex !== -1 && trackerIndex + 1 < lines.length) {
        const nextLine = lines[trackerIndex + 1];
        if (/^\d+$/.test(nextLine.trim())) {
          comment = nextLine.trim();
        }
      }

      // Find pick and odds
      const pickLine = lines.find((line) => line.includes("Pick"));
      let pick = "";
      let odds = 0;
      if (pickLine) {
        const pickParts = pickLine.split("@");
        pick = pickParts[0].replace("Pick", "").trim();
        odds = parseFloat(pickParts[1] || "0");
      }

      // Find market
      const marketLine = lines.find((line) => line.includes("Market"));
      const market = marketLine ? marketLine.replace("Market", "").trim() : "";

      // Find Outcome
      const outcomeLine = lines.find((line) => line.includes("Outcome"));
      const outcome = outcomeLine
        ? outcomeLine.replace("Outcome", "").trim()
        : "";

      // find Ft Score
      const ftScoreLine = lines.find((line) => line.includes("FT Score"));
      let ftScore = "0:0";
      if (ftScoreLine) {
        // Look for score in the next line
        const scoreIndex = lines.indexOf(ftScoreLine);
        if (scoreIndex !== -1 && scoreIndex + 1 < lines.length) {
          const scoreLine = lines[scoreIndex + 1];
          if (scoreLine.includes(":")) {
            ftScore = scoreLine.trim();
          }
        }
      }

      return {
        country: {
          short: "Gha",
          long: "Ghana",
        },
        league: "Ghana",
        teams: {
          home: {
            short: homeTeam,
            long: homeTeam,
          },
          away: {
            short: awayTeam,
            long: awayTeam,
          },
        },
        tip: {
          short: outcome ? outcome : pick,
          long: outcome ? market + " - " + outcome : market + " - " + pick,
        },
        time: dateTime.split(" ")[1],
        // odds,
        // market,
        // gameId,
        // ftScore,
        // matchStatus: isBookBet ? "notStart" : "won",
        // comment,
        outcome: true,
      };
    });

    setFormData({
      ...formData,
      betList: parsedBets,
    });
    // console.log(parsedBets);
  };

  const handleDeleteBet = async () => {
    if (!formData.title) {
      alert("Please enter a title to delete the bet");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.delete(`/bet/${formData.title}`);

      if (response.status === 200) {
        alert("Bet deleted successfully!");
        setFormData({
          title: "",
          titleLong: "",
          plan: "",
          odds: "",
          betRefUrl: [
            { type: "Sporty", url: "" },
            { type: "Betway", url: "" },
          ],
          betList: [],
        });
      }
    } catch (error) {
      console.error("Error:", error);
      alert(error.response?.data?.message || "Error deleting bet");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdatePrice = async () => {
    const newPrice = parseFloat(priceInput);
    if (isNaN(newPrice) || newPrice < 0) {
      alert("Please enter a valid non-negative price");
      return;
    }

    setUpdatingPrice(true);

    try {
      const response = await axios.put("/price", { price: newPrice });

      if (response.status === 200) {
        alert("VIP price updated successfully!");
        setPriceInput("");
      }
    } catch (error) {
      console.error("Error updating price:", error);
      alert(error.response?.data?.message || "Error updating VIP price");
    } finally {
      setUpdatingPrice(false);
    }
  };

  return (
    <div className="add_bet_container">
      <NavLink to="/home" className="main_logo">
        <img src="/logo.webp" alt="logo" className="logo_image" />
        {/* <h2>PayoutProphet</h2> */}
        <div className="logo_text">
          <span>Asakaa Play</span>
          {/* <span>Play</span> */}
        </div>
      </NavLink>

      <div className="add_bet_wrapper">
        <h1>Add New Bet</h1>

        <form onSubmit={handleSubmit}>
          {/* Main Bet Info */}
          <section className="form_section">
            <h2>Bet Information</h2>

            <div className="form_row">
              {/* <div className="form_group">
                <label htmlFor="plan">Plan *</label>
                <input
                  type="text"
                  id="plan"
                  name="plan"
                  value={formData.plan}
                  onChange={handleMainInputChange}
                  placeholder="e.g., expert free"
                  required
                />
              </div> */}

              <div className="form_group">
                <label htmlFor="title">Title *</label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  value={formData.title}
                  onChange={handleMainInputChange}
                  placeholder="e.g., expert, daily or premium"
                  required
                />
              </div>

              <div className="form_group">
                <label htmlFor="titleLong">Title Long *</label>
                <input
                  type="text"
                  id="titleLong"
                  name="titleLong"
                  value={formData.titleLong}
                  onChange={handleMainInputChange}
                  placeholder="e.g., Expert Bet"
                  required
                />
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: ".5rem",
                }}
              >
                <label
                  htmlFor="isResuts"
                  style={{
                    color: "white",
                  }}
                >
                  Is A Result
                </label>

                <input
                  type="checkbox"
                  name="isResuts"
                  onChange={(e) => setIsResult(e.target.checked)}
                  // size={20}
                />
              </div>

              <div className="form_group">
                <label htmlFor="odds">Odds *</label>
                <input
                  type="number"
                  id="odds"
                  name="odds"
                  step="0.01"
                  value={formData.odds}
                  onChange={handleMainInputChange}
                  placeholder="e.g., 13.56"
                  required
                />
              </div>
            </div>
          </section>

          {/* Bet Reference URLs */}
          <section className="form_section">
            <h2>Bet Reference URLs</h2>

            {formData.betRefUrl.map((ref, index) => (
              <div key={index} className="form_group">
                <label htmlFor={`betRef-${index}`}>{ref.type} URL</label>
                <input
                  type="url"
                  id={`betRef-${index}`}
                  value={ref.url}
                  onChange={(e) =>
                    handleBetRefChange(index, "url", e.target.value)
                  }
                  placeholder={`Enter ${ref.type} URL`}
                />
              </div>
            ))}
          </section>

          {/* Add Bet Items */}
          {/* <section className="form_section">
            <h2>Add Bets</h2>

            <div className="form_row">
              <div className="form_group">
                <label>Country Long *</label>
                <input
                  type="text"
                  value={currentBet.country.long}
                  onChange={(e) =>
                    handleCurrentBetChange("country", "long", e.target.value)
                  }
                  placeholder="e.g., Austria"
                />
              </div>
              <div className="form_group">
                <label>Country Short *</label>
                <input
                  type="text"
                  value={currentBet.country.short}
                  onChange={(e) =>
                    handleCurrentBetChange("country", "short", e.target.value)
                  }
                  placeholder="e.g., Aus"
                  maxLength="3"
                />
              </div>
            </div>

            <div className="form_group">
              <label>League *</label>
              <input
                type="text"
                value={currentBet.league}
                onChange={(e) =>
                  handleCurrentBetChange("league", null, e.target.value)
                }
                placeholder="e.g., Austria"
              />
            </div>

            <div className="form_divider">Home Team</div>
            <div className="form_row">
              <div className="form_group">
                <label>Home Team Long *</label>
                <input
                  type="text"
                  value={currentBet.teams.home.long}
                  onChange={(e) =>
                    handleCurrentBetChange("teams", "home.long", e.target.value)
                  }
                  placeholder="Full team name"
                />
              </div>
              <div className="form_group">
                <label>Home Team Short *</label>
                <input
                  type="text"
                  value={currentBet.teams.home.short}
                  onChange={(e) =>
                    handleCurrentBetChange(
                      "teams",
                      "home.short",
                      e.target.value
                    )
                  }
                  placeholder="Short name"
                />
              </div>
            </div>

            <div className="form_divider">Away Team</div>
            <div className="form_row">
              <div className="form_group">
                <label>Away Team Long *</label>
                <input
                  type="text"
                  value={currentBet.teams.away.long}
                  onChange={(e) =>
                    handleCurrentBetChange("teams", "away.long", e.target.value)
                  }
                  placeholder="Full team name"
                />
              </div>
              <div className="form_group">
                <label>Away Team Short *</label>
                <input
                  type="text"
                  value={currentBet.teams.away.short}
                  onChange={(e) =>
                    handleCurrentBetChange(
                      "teams",
                      "away.short",
                      e.target.value
                    )
                  }
                  placeholder="Short name"
                />
              </div>
            </div>

            <div className="form_divider">Bet Tip</div>
            <div className="form_row">
              <div className="form_group">
                <label>Tip Long *</label>
                <input
                  type="text"
                  value={currentBet.tip.long}
                  onChange={(e) =>
                    handleCurrentBetChange("tip", "long", e.target.value)
                  }
                  placeholder="e.g., Draw No Bet - Home Win"
                />
              </div>
              <div className="form_group">
                <label>Tip Short *</label>
                <input
                  type="text"
                  value={currentBet.tip.short}
                  onChange={(e) =>
                    handleCurrentBetChange("tip", "short", e.target.value)
                  }
                  placeholder="e.g., DNB - Home win"
                />
              </div>
            </div>

            <div className="form_group">
              <label>Time *</label>
              <input
                type="time"
                value={currentBet.time}
                onChange={(e) =>
                  handleCurrentBetChange("time", null, e.target.value)
                }
              />
            </div>

            <button
              type="button"
              className="btn_add_bet"
              onClick={addBetToList}
            >
              + Add Bet
            </button>
          </section> */}

          <div className="form_group">
            <label>Paste Bet Here *</label>
            <input
              type="text"
              value={pasteText}
              onPaste={parseBetValue}
              onChange={(e) => setPasteText(e.target.value)}
              placeholder="Paste Bet"
            />
          </div>

          {/* Bet List Preview */}
          {formData.betList.length > 0 && (
            <section className="form_section">
              <h2>Bets Added ({formData.betList.length})</h2>
              <div className="bets_list">
                {formData.betList.map((bet, index) => (
                  <div key={index} className="bet_item">
                    <div className="bet_info">
                      <p>
                        <strong>{bet.country.long}</strong> - {bet.league}
                      </p>
                      <p>
                        {bet.teams.home.long} vs {bet.teams.away.long}
                      </p>
                      <p>
                        Tip: {bet.tip.long} @ {bet.time}
                      </p>
                    </div>
                    <button
                      type="button"
                      className="btn_remove_bet"
                      onClick={() => removeBetFromList(index)}
                    >
                      Remove
                    </button>

                    {isResuts && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: ".5rem",
                        }}
                      >
                        <label
                          htmlFor="isResuts"
                          style={{
                            color: "white",
                          }}
                        >
                          Is Won
                        </label>

                        <input
                          type="checkbox"
                          name="isResuts"
                          // onChange={(e) => setIsResult(e.target.checked)}
                          // size={20}
                          checked={bet.outcome}
                          onChange={(e) =>
                            toggleBetResult(index, e.target.checked)
                          }
                        />
                      </div>
                    )}

                    {/* <button
                      type="button"
                      className="btn_remove_bet"
                      style={{
                        backgroundColor: "green"
                      }}
                      onClick={() => editBetFromList(index)}
                    >
                      Edit
                    </button> */}
                  </div>
                ))}
              </div>
            </section>
          )}

          {/* Submit Button */}
          <div className="form_actions">
            <button type="submit" className="btn btn_submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit Bet"}
            </button>
          </div>
        </form>
      </div>

      <div className="form_actions">
        <button
          onClick={handleDeleteBet}
          className="btn btn_remove_bet"
          style={{
            backgroundColor: "red",
          }}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Delete Bet"}
        </button>
      </div>

     
 <div style={{ color: "#fff", fontWeight: 700, marginTop: "3rem", textAlign: "center" }}>
        Change VIP price:
      </div>
      <div
        className="vip_price_box"
        style={{
          display: "flex",
          gap: "0.6rem",
          alignItems: "center",
          paddingBottom: "3rem",
        }}
      >
        <input
          type="number"
          step="0.01"
          value={priceInput}
          onChange={(e) => setPriceInput(e.target.value)}
          placeholder="New price"
          style={{
            padding: "0.45rem 0.6rem",
            borderRadius: 8,
            border: "1px solid rgba(255,255,255,0.08)",
            background: "rgba(0,0,0,0.4)",
            color: "#fff",
            width: 120,
          }}
        />

        <button
          type="button"
          onClick={handleUpdatePrice}
          disabled={updatingPrice}
          className="btn btn_submit"
          style={{ padding: "0.45rem 0.8rem" }}
        >
          {updatingPrice ? "Updating..." : "Update VIP Price"}
        </button>
      </div>
    </div>
  );
};

export default AddBet;
